(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {LENGTHS,FABRICS,LAYERS,RIDGELINES,SUSPENSIONS,MAIN_SACKS}=window.SLDEstimatorData.products["starter"];

  const FIELD_LABELS = Object.freeze({
    'Length * (required)': 'Length',
    "Fabric/Color * (required)": 'Fabric',
    'Layers * (required)': 'Layers',
    'Ridgeline * (required)': 'Ridgeline',
    'Suspension * (required)': 'Suspension'
  });

  

  

  

  

  
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const domLabel = clean(element.labels && element.labels[0] && element.labels[0].textContent);
      if (!own(FIELD_LABELS, domLabel)) continue;
      const field = FIELD_LABELS[domLabel];
      selected[field] = field === 'Layers' ? element.value : clean(element.value);
    }
    return selected;
  }

  function estimate(choice) {
    const length = LENGTHS[choice.Length];
    const fabric = FABRICS[choice.Fabric];
    const ridgeline = RIDGELINES[choice.Ridgeline];
    const suspension = SUSPENSIONS[choice.Suspension];
    if (!length || !fabric || !ridgeline || !suspension || !own(LAYERS, choice.Layers)) return null;
    const layers = LAYERS[choice.Layers];

    const body = ((length * 12 + 8) * fabric.width / 1296) * fabric.density * layers + fabric.overhead;
    const hammock = body + ridgeline[length];
    const withSuspension = hammock + suspension.weight;
    const packed = withSuspension + MAIN_SACKS[length] + suspension.sack;
    return { body, hammock, withSuspension, packed };
  }

  function start() {
    const root = document.querySelector('[data-sld-starter-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      if (!result) {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Select the required options above to see estimated weights.';
        return;
      }

      const set = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value.toFixed(1) + ' oz / ' + Math.round(value * 28.349523125) + ' g';
      };
      set('[data-sld-weight-hammock]', result.hammock);
      set('[data-sld-weight-suspension]', result.withSuspension);
      set('[data-sld-weight-packed]', result.packed);
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { estimate, selections, start };
});
